import React, { Component } from 'react';
import { api_url, headers } from '../../common/config';
import i18next from 'i18next';
import { Link } from 'react-router-dom';

class AutismArticlesCard extends Component {
    constructor(props) {
        super(props);

        this.state = {
            image: '',
            article: '',
        };
    }

    componentDidMount() {
        this.getImage();
        this.getArticle();
    }

    getImage = () => {
        if (this.props.image !== undefined) {
            fetch(`${api_url}/autism/files/${this.props.image}`, {
                method: 'GET',
                // headers: headers,
            })
                .then((res) => res.json())
                .then((res) => {
                    this.setState({
                        image: res.data.data.full_url,
                    });
                });
        }
    };

    getArticle = () => {
        if (this.props.file !== undefined) {
            fetch(`${api_url}/autism/files/${this.props.file}`, {
                method: 'GET',
                // headers: headers,
            })
                .then((res) => res.json())
                .then((res) => {
                    this.setState({
                        article: res.data.data.full_url,
                    });
                });
        }
    };
    render() {
        return (
            <div className='autism-articles-card'>
                <Link to={`/blog/article/${this.props.article}`}>
                    <img width='85%' src={this.state.image} alt='' />
                    <h1 className='autism-article-title'>
                        {i18next.language === 'ar'
                            ? `${this.props.title}`
                            : `${this.props.en_title}`}
                    </h1>
                </Link>
            </div>
        );
    }
}

export default AutismArticlesCard;
